import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DayTime {


    calcEndDate(days: number, hasExp: boolean = false, expDays: number = 0) {
        let businessTime = days;
        businessTime = businessTime == 1 ? businessTime + 1 : businessTime;

        let today = new Date();
        let day = today.getDay();

        let diff = (1 - day + 7) % 7; //This line calculates the difference between the current day and the next Monday.
        if (today.getDay() == 6 || today.getDay() == 0 || today.getDay() == 0) {
            today.setDate(today.getDate() + (diff));
        }

        let newDate = new Date(today.setDate(today.getDate()));

        for (let i = 0; i < businessTime;) {
            newDate.setDate(newDate.getDate() + 1);
            if (newDate.getDay() != 6 && newDate.getDay() != 0 && this.isHoliday(newDate.getDate(), newDate.getMonth(), newDate.getFullYear()) === undefined && !(hasExp && newDate.getDay() == 5 && i <= expDays)) {
                i++
            }
        }

        return newDate;
    }

    formatDate(date: any) {
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        const dayName = days[date.getDay()];
        const monthName = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();

        // Add suffix for day
        const daySuffix = (day: number) => {
            if (day > 3 && day < 21) return 'th'; // 4th to 20th
            switch (day % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };
        // if (insideTable) {
        //     return `${monthName} ${day}`;
        // }
        return ` ${monthName} ${day}, ${year}`;
    }


    // Function to check if a date is a holiday
    isHoliday(day: number, month: number, year: number) {
        const holidays = [
            { date: new Date(year, 0, 1), name: "New Year's" }, // January 1
            { date: this.getNthWeekdayOfMonth(3, 1, 0, year), name: "M.L.K. Day" }, // Third Monday in January
            { date: this.getNthWeekdayOfMonth(3, 1, 1, year), name: "President" }, // Third Monday in February
            { date: this.getNthWeekdayOfMonth(4, 1, 4, year), name: "Memorial " }, // Last Monday in May
            // { date: this.getNthWeekdayOfMonth(3, 0, 5, currentY.e: "Father's Day" }, // Third Sunday in June
            { date: new Date(year, 6, 4), name: "Ind. Day" }, // July 4
            { date: this.getNthWeekdayOfMonth(1, 1, 8, year), name: "Labor Day" }, // First Monday in September
            { date: this.getNthWeekdayOfMonth(2, 1, 9, year), name: "Columbus" }, // Second Monday in October
            { date: new Date(year, 10, 11), name: "Veterans" },  // 11 November
            { date: this.getNthWeekdayOfMonth(4, 4, 10, year), name: "T.G. Day" }, // Fourth Thursday in November
            { date: new Date(year, 11, 25), name: "Christmas" }, // December 25
            // Add other fixed holidays as above
        ];
        return holidays.find(
            (holiday) =>
                holiday.date.getDate() === day &&
                holiday.date.getMonth() === month &&
                holiday.date.getFullYear() === year
        );
    }

    getNthWeekdayOfMonth(n: number, weekday: number, month: number, year: number) {
        let date = new Date(year, month, 1);
        let day = date.getDay();
        let diff = (weekday - day + 7) % 7 + (n - 1) * 7;
        return new Date(year, month, 1 + diff);
    }
}
